import React from "react";
import { Instagram } from "lucide-react";
import Logo from "./Logo";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-nyg-dark text-nyg-cream border-t border-nyg-cream/10 py-14 md:py-20"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16 grid grid-cols-12 gap-8 items-start">
        <div className="col-span-12 md:col-span-5">
          <Logo size={56} tone="cream" />
          <p className="font-body font-light text-sm text-nyg-cream/60 mt-8 max-w-xs">
            An art collective bridging the United Kingdom, Turkey and Greece.
          </p>
        </div>

        <div className="col-span-6 md:col-span-3">
          <span className="label !text-nyg-cream/50 block mb-3">Contact</span>
          <a
            href="mailto:info@nygprojects.com"
            className="font-body text-base text-nyg-cream hover:text-nyg-cream/70 transition-colors block"
            data-testid="footer-email"
          >
            info@nygprojects.com
          </a>
          <a
            href="https://instagram.com/nyg_projects"
            target="_blank"
            rel="noopener noreferrer"
            className="font-body text-base text-nyg-cream hover:text-nyg-cream/70 transition-colors mt-3 inline-flex items-center gap-2"
            data-testid="footer-instagram"
          >
            <Instagram size={16} strokeWidth={1.2} />
            @nyg_projects
          </a>
        </div>

        <div className="col-span-6 md:col-span-4 md:text-right">
          <span className="label !text-nyg-cream/50 block mb-3">Cities</span>
          <p className="font-body font-light text-base text-nyg-cream/80">
            London · Istanbul · Athens
          </p>
          <p className="label !text-nyg-cream/40 mt-6">
            © {new Date().getFullYear()} NYG Projects
          </p>
        </div>
      </div>
    </footer>
  );
}
